import React from 'react';
import { IAuditoriaRastreabilidadeBancariaResultado } from '../interfaces/IAuditoriaRastreabilidadeBancaria';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaRastreabilidadeBancariaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Qualidade de Dados Bancários (Rastreabilidade) não é um tributo — é uma auditoria
// de governança/conformidade que identifica lançamentos em contas de movimento bancário sem Razão
// Social e/ou Número de Documento identificáveis no histórico. Segue o mesmo padrão de seção
// própria já usado para Zeramento de 13º, Baixa Patrimonial e Benefícios Indiretos.
const AuditoriaResumoRastreabilidadeBancaria: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.errosRastreabilidade?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Rastreabilidade Bancária</h3>
      <p className='text-muted'>
        Auditoria de governança — lançamentos em contas de movimento bancário devem identificar o participante
        (nome/razão social/pessoa física) e o Número de Documento/Nota Fiscal no histórico (IN RFB nº 2.003/2021). Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD Potencial</th>
              <th className='text-center'>
                Risco Fiscal
                <div style={{ fontSize: 10, fontWeight: 400, color: '#64748b' }}>Erros</div>
              </th>
              <th className='text-center'>
                Qualidade Cadastral
                <div style={{ fontSize: 10, fontWeight: 400, color: '#64748b' }}>Avisos</div>
              </th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_RASTREABILIDADE_BANCARIA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Rastreabilidade Bancária</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} conta{totalOcorrencias === 1 ? '' : 's'} bancária{totalOcorrencias === 1 ? '' : 's'} com indício identificado no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                  <div className='mt-1 d-flex gap-2 flex-wrap' style={{ fontSize: 11 }}>
                    <span style={{ background: '#fee2e2', color: '#991b1b', padding: '1px 6px', borderRadius: 4 }}>
                      Erros = risco fiscal com multa estimada
                    </span>
                    <span style={{ background: '#fef3c7', color: '#92400e', padding: '1px 6px', borderRadius: 4 }}>
                      Avisos = qualidade cadastral sem multa
                    </span>
                  </div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% limitada a 1% da receita bruta do período — por inexatidão no SPED (Art. 12, II, Lei nº 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoRastreabilidadeBancaria;
